import React from 'react';

import MilestoneContainer from '../containers/milestone-container';
import TaskGroupName from './task-group-name';

const Name = ({ name = null, task_group, removed }) => {
    if (removed) {
        return '(Removed Milestone)';
    }

    if (task_group) {
        return <TaskGroupName id={task_group} />;
    }

    return name;
};

const MilestoneName = ({ id }) => <MilestoneContainer id={id}><Name /></MilestoneContainer>;

export default MilestoneName;
